import store from "@/store";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';
import tableStoreService from "@/components/base_components/tables/services/table-store-service";

var toDecorator = (function() {

  var _withReplace = false;

  /**
   * @param {Route} to
   * @returns {*}
   */
  var decorateTo = function(to) {
    _withReplace = false;
    return _handleDecorations(to);
  }

  var _handleDecorations = function(to) {
    return runTableIdDecoration(to);
  }

  var runTableIdDecoration = function(to) {
    if (hasType(to, DECORATION_TYPES.GENERATE_TABLE_CACHE_ID) && to.query['tableCacheId'] == undefined) {
      to.query['tableCacheId'] = tableStoreService.generateTableIdentifier(to.meta.moduleId, store.state.tableStore);
      _withReplace = true;
    }

    return _withReplace;
  }

  var hasType = function(to, type) {
    return to?.meta?.decorations != undefined && to.meta.decorations.includes(type);
  }

  return { decorateTo: decorateTo }
})();

export default toDecorator;
